import type { BrandFile } from '@hub/common';

/** The address of the logo the participant pages show: the light logo. */
export const brandLogoUrl = (
  file: BrandFile | null | undefined
): string | undefined => file?.light.logo?.url;
